module.exports = __webpack_public_path__ + "static/media/gymtracker-thumbnail.0d61d724.png";